import React from "react";
import { Col, Input, Label } from "reactstrap";

/** Matches the backend limit (ProductDescription.MAX_LENGTH). */
export const PRODUCT_DESCRIPTION_MAX = 2000;

type Props = {
  value?: string;
  onChange: (value: string) => void;
};

/** Optional buyer-facing description, full width under name and colour. */
export default function ProductDescriptionField({ value, onChange }: Props) {
  const text = value || "";
  return (
    <Col xs={12}>
      <Label htmlFor="productDescription">Description (optional)</Label>
      <Input
        type="textarea"
        id="productDescription"
        name="productDescription"
        className="form-control"
        rows={4}
        maxLength={PRODUCT_DESCRIPTION_MAX}
        placeholder="What makes this piece special: how it was made, materials, its story"
        value={text}
        onChange={(e: any) => onChange(e.target.value)}
      />
      <small className="text-muted">
        {text.length}/{PRODUCT_DESCRIPTION_MAX}
      </small>
    </Col>
  );
}
